export default "__VITE_ASSET__CA_e3AKC__"